import { Button } from '@/view/components/ui/button'
import { Link } from 'react-router-dom'
import { useCodeRecoveryController } from './useCodeRecoveryController'

interface CodeRecoveryProps {
  cpf: string
  onTokenSet: (token: string) => void
}

export const CodeRecovery = ({ cpf, onTokenSet }: CodeRecoveryProps) => {
  const {
    handleFormSubmit,
    isPending,
    code,
    inputRefs,
    handleCodeInput,
    isCodeEntered,
    handleSendCode,
  } = useCodeRecoveryController({ cpf, onTokenSet })

  return (
    <div className="flex flex-col gap-6 text-black03">
      <div className="text-center">
        <h2 className="mb-4 text-xl font-semibold text-gray-900">
          Verificação de código
        </h2>
        <p className="text-sm text-black03">
          Confirme o código que foi enviado para o seu e-mail.
        </p>
      </div>

      <form
        onSubmit={(e) => {
          e.preventDefault()
          handleFormSubmit()
        }}
        className="flex w-full flex-col gap-4"
      >
        <div className="flex flex-col items-center gap-3">
          <label className="text-sm font-medium">Código de verificação</label>
          <div className="flex justify-center gap-2">
            {code.map((_, index: number) => (
              <input
                key={index}
                className="flex h-12 w-12 items-center justify-center border-b-2 border-gray-300 text-center text-lg font-bold focus:border-b-2 focus:border-primary focus:outline-none"
                maxLength={1}
                onChange={(e) => handleCodeInput(e.target.value, index)}
                value={code[index]}
                ref={(ref) => {
                  inputRefs.current[index] = ref
                }}
                onKeyPress={({ nativeEvent }) => {
                  if (nativeEvent.key === 'Backspace') {
                    handleCodeInput('', index)
                  }
                }}
              />
            ))}
          </div>
        </div>

        <Button
          type="submit"
          disabled={isPending || !isCodeEntered}
          className="my-4 h-14 w-full bg-primary text-lg font-bold text-white01 hover:bg-primary hover:brightness-150"
        >
          {isPending ? 'Verificando...' : 'Continuar'}
        </Button>

        <Button
          type="button"
          variant="outline"
          onClick={handleSendCode}
          className="h-10 text-sm"
        >
          Reenviar código
        </Button>

        <Link className="text-center" to="/">
          Voltar para login
        </Link>
      </form>
    </div>
  )
}
